import styled from 'styled-components'

interface IDebugProps {
  debug?: boolean
}
interface ISizeProps {
  size?: number
  tabletSize?: number
  desktopSize?: number
  desktopLargeSize?: number
  responsiveSize?: number
  hideMobile?: boolean
  hideTablet?: boolean
  hideDesktop?: boolean
  flexShrink?: number
  flexGrow?: number
}
const SpacerDiv = styled.div<ISizeProps & IDebugProps>`
  width: ${props => props.responsiveSize || props.size || 20}px;
  height: ${props => props.responsiveSize || props.size || 20}px;
  flex-basis: ${props => props.responsiveSize || props.size || 20}px;
  flex-shrink: 0;
  flex-grow: 0;
  ${props => props.hideMobile && 'display: none;'}
  ${props => props.debug && props.theme.colors.green}
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    display: block;
    ${props => props.hideTablet && 'display: none;'}
    width: ${props => props.tabletSize || props.size || 20}px;
    height: ${props => props.tabletSize || props.size || 20}px;
    flex-basis: ${props => props.tabletSize || props.size || 20}px;
  }
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    display: block;
    ${props => props.hideDesktop && 'display: none;'}
    width: ${props => props.desktopSize || props.size || 20}px;
    height: ${props => props.desktopSize || props.size || 20}px;
    flex-basis: ${props => props.desktopSize || props.size || 20}px;
  }
  @media (min-width: ${props => props.theme.metrics.desktopLarge}px) {
    display: block;
    ${props => props.hideDesktop && 'display: none;'}
    width: ${props => props.desktopLargeSize || props.desktopSize || props.size || 20}px;
    height: ${props => props.desktopLargeSize || props.desktopSize || props.size || 20}px;
    flex-basis: ${props => props.desktopLargeSize || props.desktopSize || props.size || 20}px;
  }
`

const Spacer = (props: ISizeProps & IDebugProps) => (
  <SpacerDiv
    data-testid="spacer"
    {...props}
  />
)

export default Spacer
